export const popularSearches = [
    {
        name: "Possession",
    },
    {
        name: "Platforms",
    },
    {
        name: "Sandals",
    },
    {
        name: "Baby Sandals",
    },
    {
        name: "Kids Boots",
    },
]